
export default class pageDefinition {
  path = null;
  name = null;
  icon = null;
  requireAuth = true;
  component = null;
  roles = [];
  i18nTitle = null;
  breadcrumb = [];
  pageTitle = null;
  rule = null;
  props = null;
  featureFlag = null;
  userGuideUrl = { en: null, fr: null };

  constructor(path, name, roles, icon, i18nTitle, pageTitle, requireAuth, component, rule, featureFlag = null) {
    this.path = path;
    this.name = name;
    this.roles = roles;
    this.icon = icon;
    this.i18nTitle = i18nTitle;
    this.pageTitle = pageTitle;
    this.requireAuth = requireAuth;
    this.component = component;
    this.rule = rule;
    this.breadcrumb = [];
    this.addHomeToBreadcrumb();
    this.props = null;
    this.featureFlag = featureFlag;
  }

  toMenuItem() {
    return {
      roles : this.roles,
      icon : this.icon,
      to : this.path,
      i18nTitle : this.i18nTitle,
      featureFlag: this.featureFlag
    };
  }

  toNavMenuItem(submenu) {
    if (submenu !== undefined && submenu !== null) {
      return {
        requireRoles : this.roles,
        icon : this.icon,
        url : this.path,
        i18n : this.i18nTitle,
        name : this.pageTitle,
        slug : this.name,
        featureFlag : this.featureFlag,
        submenu
      };
    }
    
    return {
      requireRoles : this.roles,
      icon : this.icon,
      url : this.path,
      i18n : this.i18nTitle,
      name : this.pageTitle,
      slug : this.name,
      featureFlag : this.featureFlag
    };
  }

  addToBreadcrumb(title, url, active, i18n) {
    const obj = { title, url, active, i18n };
    this.breadcrumb.push(obj);
  }

  addItemToBreadcrumb(item) {
    this.breadcrumb.push(item);
  }

  addHomeToBreadcrumb() {
    this.addToBreadcrumb("Home", "/", false);
  }

  addSelfToBreadcrumb() {
    this.addToBreadcrumb(this.pageTitle, this.path, true, this.i18nTitle);
  }

  toBreadcrumb(active) {
    const obj = { title:this.pageTitle, url:this.path, active, i18n:this.i18nTitle };
    return obj;
  }

  toRoute() {
    return {
      path : this.path,
      name : this.name,
      component: this.component,
      props: this.props,
      meta: {
        breadcrumb: this.breadcrumb,
        requireAuth: this.requireAuth,
        requireRoles: this.roles,
        pageTitle: this.pageTitle,
        i18n: this.i18nTitle,
        rule: this.rule,
        featureFlag: this.featureFlag,
        userGuideUrl: this.userGuideUrl
      }
    };
  }
}